import React from 'react'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
// import PhotoGallery from './PhotoGallery'
import Preroll from './Preroll'
// import Navbar from './Navbar'

const App = ({ classes }) => {
	// const [hasVisited, setHasVisited] = useState(
	// 	localStorage.getItem('hasVisited') || false
	// )
	// useEffect(() => localStorage.setItem('hasVisited', hasVisited))
	return (
		<div className={classes.page}>
			<div className={classes.container}>
				<Router>
					{/* {hasVisited && (
						<Route
							path="/"
							render={({ location }) => <Navbar location={location} />}
						/>
					)} */}
					<Switch>
						<Route path="/" component={Preroll} />
						{/* <Route path="/preroll" exact component={Preroll} /> */}
						{/* <Route
							path="/photos"
							exact
							render={() => <PhotoGallery setHasVisited={setHasVisited} />}
						/> */}
					</Switch>
				</Router>
			</div>
		</div>
	)
}

export default withStyles(theme => ({
	page: {
		backgroundColor: '#f6d9cc'
	},
	container: {
		margin: '0 auto',
		padding: '10px 7%',
		maxWidth: '1600px',
		[theme.breakpoints.down('xs')]: {
			padding: '0'
		}
	}
}))(App)
